
export class Preset
{
    public Name: string; // ex. "low", "high", "custom"
    public Label: string; // ex. "400x300", "Custom #1"
    public Width: number;
    public Height: number;
    public Brightness: number;
    public Contrast: number;
    public Rotation: number;

    constructor(name: string, label: string, width: number, height: number, brightness: number, contrast: number, rotation: number)
    {
        this.Name = name;
        this.Label = label;
        this.Width = width;
        this.Height = height;
        this.Brightness = brightness;
        this.Contrast = contrast;
        this.Rotation = rotation;
    }
}
